import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

/**
 * Commponent for generic text fields
 */
@UntilDestroy()
@Component({
  selector: '[app-form-field-search]',
  templateUrl: './form-field-search.component.html',
})
export class FormFieldSearchComponent implements OnInit, OnDestroy {
  @HostBinding('class.esf-form-item') public get formItemClass(): boolean {
    return true;
  }
  @ViewChild('searchBox', { static: true }) public searchElement: ElementRef;
  public searchInput: any = new Subject<string>();
  public isBlurred: boolean;

  @Input() public optional: boolean = false;
  @Input() public placeholder: string = '';
  @Input() public control: AbstractControl;
  @Input() public id: string;

  @Output() public enterPressed: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();
  @Output() public inputChanged: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  get formControl(): UntypedFormControl {
    return this.control as UntypedFormControl;
  }

  public ngOnInit(): void {
    if (this.control) {
      this.searchInput
        .pipe(
          untilDestroyed(this),
          debounceTime(900),
          distinctUntilChanged(),
        )
        .subscribe((event: any) => {
          this.inputChanged.emit(event);
          this.isBlurred = true;
        });
      this.searchElement?.nativeElement.focus();
    } else {
      this.searchInput
        .pipe()
        .subscribe((event: any) => this.inputChanged.emit(event));
    }
  }

  public ngOnDestroy(): void { }

  /**
   * Let the parent component know that the enter key was pressed.
   */
  public enterKeyDown(event?: any): any {
    this.isBlurred = true;
    this.enterPressed.emit(event);
  }

}
